import TagManager from "react-gtm-module"

import type { IIndexable } from "@common-shared/types/general.types"

import { AnalyticsEvent } from "../config/analytics.config"

/**
 * Class for working with analytics that we have behind our application
 * At the moment we are using: gTagManager -> GoogleAnalytics
 */
export class AnalyticsHelper {
    /**
     * Fire some event to our analytics provider
     * Make sure these events are properly configured (trigger + GA4 Event tag) in tag manager
     */
    static event(event: AnalyticsEvent, data: IIndexable = {}) {
        if (!import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID) {
            return
        }

        try {
            TagManager.dataLayer({
                dataLayer: {
                    event,
                    ...data,
                },
            })
        } catch (e) {}
    }
}
